
        var result = require("!!../../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.97.1/node_modules/css-loader/dist/cjs.js??clonedRuleSet-2065.use[1]!../../../../../../node_modules/.pnpm/postcss-loader@4.3.0_postcss@8.5.2_webpack@5.97.1/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-2065.use[2]!../../../../../../node_modules/.pnpm/fast-sass-loader@2.0.1_sass@1.25.0_webpack@5.97.1/node_modules/fast-sass-loader/lib/index.js??clonedRuleSet-2065.use[3]!./styles.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    